<template>
  <div class="search-video-standard container">
    <el-form ref="form" :model="form" :rules="rules" size="small">
      <create-choice
        :contentArr="['短视频/图文带货', '搜索广告', '专业推广']"
        @onChange="show = true"
      />

      <choose-account title="请选择要推广的商品" type="video" />

      <div class="product">
        <product-selecter :product="product" @onConfirm="onChooseProduct" />
      </div>

      <search-terms :form="form" :haveProduct="!!product" :list="wordList" />

      <div>
        <p class="level-2">
          智选流量
          <el-popover placement="top" trigger="hover" width="330">
            <p style="font-size: 12px; line-height: 1.8">
              开启后系统将在关键词的基础上，智能识别并扩展相似流量，帮助计划跑量。如：
            </p>
            <p style="font-size: 12px; line-height: 1.8">
              计划投放已[台灯为主]，智选流量将为您新增“床头灯、小夜灯”等流量，帮助拓量
            </p>
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </p>
        <el-radio-group v-model="form.flow" size="medium">
          <el-radio-button label="开启"></el-radio-button>
          <el-radio-button label="关闭"></el-radio-button>
        </el-radio-group>
      </div>

      <delivery-setting :form="form" />

      <div class="creative">
        <p class="level-1">请为商品添加创意</p>
        <add-video
          :videoNum="videoNum"
          :videoMax="7"
          :isSearch="true"
          :disabled="!product"
          title="添加创意内容"
          rightBtn="根据商品智能生成视频"
          @onConfirm="onConfirm"
        />
        <div class="auto-checkbox">
          <el-checkbox v-model="form.autoCreative" :disabled="!product"
            >动态创意
            <el-popover placement="top" trigger="hover" width="300">
              <p style="font-size: 12px; line-height: 1.8">
                基于用户特征和用户搜索的关键词等,动态展示符合搜索意图的创意素材、标题、推广卡片等,搭配最合适的创意从而提升广告的点击转化率
              </p>
              <i class="el-icon-question" slot="reference"></i>
            </el-popover>
          </el-checkbox>
        </div>

        <div class="creative-preview">
          <div class="title-section">
            <p class="title-text">创意预览</p>
            <div class="change-arrow">
              <i class="el-icon-back icon mr"></i>
              <i class="el-icon-right icon"></i>
            </div>
          </div>
          <div class="change-apps">
            <div
              class="tab-item"
              v-for="(tab, i) in tabs"
              :key="i"
              :class="{ active: currentApp == tab.name }"
              @click="currentApp = tab.name"
            >
              <el-tooltip :content="tab.name" placement="top">
                <el-image
                  style="width: 32px; height: 32px"
                  :src="tab.icon"
                  fit="contain"
                ></el-image>
              </el-tooltip>
            </div>
          </div>
          <div class="component-preview-wrapper">
            <div class="video">
              <el-image
                v-if="videoNum > 0"
                class="cover"
                :src="
                  require(`@/assets/images/simulation/s_preview_${
                    currentApp == '抖音' ? 'dy' : 'tt'
                  }.png`)
                "
                fit="cover"
              ></el-image>
              <div class="not-support" v-else>
                <el-image
                  style="width: 100px; height: 72px"
                  :src="require('@/assets/images/simulation/empty.png')"
                  fit="cover"
                ></el-image>
                <p class="empty-text">该广告位暂不支持该创意类型</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <landing-page :havePorduct="!!product" @backTop="backTop" />

      <div class="switch-bottom">
        <p class="level-2">
          抖音主页隐藏视频
          <el-popover placement="top" trigger="hover">
            <p style="font-size: 12px">
              隐藏后，用户在你的选择的抖音号的主页看不到新增的视频创意
            </p>
            <p style="margin-top: 5px; color: #909399; font-size: 12px">
              注意：计划自动生成的视频创意将默认隐藏，不跟随设置变化
            </p>
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </p>
        <el-radio-group v-model="form.hide" size="medium">
          <el-radio-button label="隐藏"></el-radio-button>
          <el-radio-button label="不隐藏"></el-radio-button>
        </el-radio-group>
      </div>

      <creative-label :form="form" />

      <form-bottom
        :form="form"
        :show="show"
        @onSubmit="handleRelease"
        @onClose="show = false"
        @onCancel="show = true"
      />
    </el-form>
  </div>
</template>

<script>
import AddVideo from "../components/addVideo.vue";
import ChooseAccount from "../components/chooseAccount.vue";
import createChoice from "../components/createChoice.vue";
import ProductSelecter from "../components/productSelecter.vue";
import SearchTerms from "../components/searchTerms.vue";
import DeliverySetting from "./deliverySetting.vue";
import LandingPage from "../components/landingPage.vue";
import CreativeLabel from "../components/creativeLabel.vue";
import FormBottom from "../components/formBottom.vue";
import { submit } from "@/api/chapterMock";

export default {
  components: {
    createChoice,
    ChooseAccount,
    ProductSelecter,
    AddVideo,
    DeliverySetting,
    SearchTerms,
    LandingPage,
    CreativeLabel,
    FormBottom,
  },
  data() {
    var checkBudget = (rule, value, callback) => {
      if (!value) {
        return callback(
          new Error("预算不少于300元，不超过9999999.99元，请正确输入")
        );
      }
      if (isNaN(value)) {
        callback(new Error("仅支持输入数字"));
      } else {
        if (value < 300 || value > 9999999.99) {
          callback(
            new Error("预算不少于300元，不超过9999999.99元，请正确输入")
          );
        } else {
          callback();
        }
      }
    };
    var checkBid = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("出价不少于0.1元，不超过10000元"));
      }
      if (isNaN(value)) {
        callback(new Error("仅支持输入数字"));
      } else {
        if (value < 0.1 || value > 10000) {
          callback(new Error("出价不少于0.1元，不超过10000元"));
        } else {
          callback();
        }
      }
    };
    return {
      product: null,
      videoNum: 0,
      form: {
        keywords: [],
        flow: "开启",
        mode: "控成本投放",
        limit: false,
        deliverySpeed: "尽快投放",
        action: "商品购买",
        budget: null,
        budgetType: "日预算",
        bid: null,
        dateType: "从今天起长期投放",
        startTime: "",
        endTime: "",
        timeIntervalType: "不限",
        directional: "自定义人群",
        audience: {
          region: "不限",
          regionArr: [],
          audienceType: "正在该地区的用户",
          sex: "不限",
          age: [],
          network: [],
          platform: "不限",
          autoExtend: "关闭",
        },
        hide: "隐藏",
        autoCreative: true,
        creativeClass: "",
        adName: "短视频_PC_搜索",
        adGroup: "搜索-短视频/图文带货-系统默认分组",
      },
      wordList: [
        { id: 1, word: "t恤", matchingMode: "广泛" },
        { id: 2, word: "纯棉t恤", matchingMode: "广泛" },
        { id: 3, word: "白色t恤", matchingMode: "广泛" },
        { id: 4, word: "男t恤", matchingMode: "广泛" },
        { id: 5, word: "宽松t恤", matchingMode: "广泛" },
        { id: 6, word: "打底t恤", matchingMode: "广泛" },
        { id: 7, word: "半袖t恤", matchingMode: "广泛" },
        { id: 8, word: "纯色t恤", matchingMode: "广泛" },
        { id: 9, word: "印花t恤", matchingMode: "广泛" },
        { id: 10, word: "潮流宽松t恤", matchingMode: "广泛" },
        { id: 11, word: "速干t恤", matchingMode: "广泛" },
        { id: 12, word: "休闲t恤", matchingMode: "广泛" },
      ],
      tabs: [
        {
          name: "抖音",
          icon: require("@/assets/images/simulation/icon_douyin.png"),
        },
        {
          name: "头条",
          icon: require("@/assets/images/simulation/icon_toutiao.png"),
        },
      ],
      currentApp: "抖音",
      rules: {
        budget: {
          validator: checkBudget,
          trigger: "blur",
        },
        bid: {
          validator: checkBid,
          trigger: "blur",
        },
      },
      show: false,
    };
  },
  methods: {
    onChooseProduct(val) {
      this.product = val;
      this.form.keywords = [
        { id: 1, word: "t恤", matchingMode: "广泛" },
        { id: 2, word: "纯棉t恤", matchingMode: "广泛" },
        { id: 3, word: "白色t恤", matchingMode: "广泛" },
      ];
    },
    onConfirm(val) {
      this.videoNum = val;
    },
    // 发布计划
    handleRelease() {
      if (!this.product) {
        this.$message.warning("请添加商品");
        this.backTop();
        return;
      } else {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.$confirm(`确定要提交吗？`)
              .then(() => {
                const classChapterId = localStorage.getItem("mockChapterId");
                submit({
                  classChapterId,
                  content: JSON.stringify({
                    ...this.form,
                    ...JSON.parse(this.$route.query.form),
                  }),
                }).then((res) => {
                  this.$alert("提交成功", {
                    confirmButtonText: "确定",
                    callback: (action) => {
                      window.close();
                    },
                  });
                });
              })
              .catch(() => {});
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      }
    },
    backTop() {
      this.$el.querySelector(".create-choice").scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    },
  },
};
</script>

<style lang="less" scoped>
.search-video-standard {
  padding-top: 32px;
  padding-left: 50px;
  text-align: left;
  .product {
    margin-top: 24px;
    margin-bottom: 60px;
    width: 648px;
  }
  .level-1 {
    line-height: 34px;
    font-weight: 500;
    font-size: 24px;
    color: #111;
  }
  .level-2 {
    margin-top: 28px;
    margin-bottom: 12px;
    line-height: 20px;
    font-weight: 600;
    font-size: 14px;
    color: #333;
  }
  .el-icon-question {
    margin-left: 3px;
    color: #d3d3d3;
    font-size: 16px;
    vertical-align: -1px;
    cursor: pointer;
  }
  .creative {
    position: relative;
    .auto-checkbox {
      margin-top: 18px;
      ::v-deep .el-checkbox {
        .el-checkbox__inner {
          width: 16px;
          height: 16px;
          &:hover {
            border-color: #333;
          }
          &::after {
            left: 5px;
          }
        }
        .el-checkbox__label {
          padding-left: 5px;
          line-height: 20px;
          font-size: 14px;
          color: #333;
        }
        &.is-checked {
          .el-checkbox__inner {
            background-color: #333;
            border-color: #333;
          }
          .el-checkbox__label {
            color: inherit;
          }
        }
        .el-checkbox__input.is-focus {
          .el-checkbox__inner {
            border-color: #333;
          }
        }
      }
    }
    .creative-preview {
      position: absolute;
      top: 32px;
      right: 0px;
      width: 310px;
      padding: 24px;
      background-color: #fff;
      border: 1px solid #e3e3e4;
      border-radius: 2px;
      .title-section {
        margin-bottom: 21px;
        overflow: hidden;
        .title-text {
          font-weight: 600;
          font-size: 16px;
          line-height: 22px;
          color: #1f1f1f;
          display: inline-block;
        }
        .change-arrow {
          float: right;
          .icon {
            font-size: 20px;
            font-weight: bold;
            color: #999;
            cursor: not-allowed;
            &.mr {
              margin-right: 27px;
            }
          }
        }
      }
      .change-apps {
        margin-bottom: 15px;
        .tab-item {
          display: inline-block;
          opacity: 0.5;
          cursor: pointer;
          &.active {
            opacity: 1;
          }
          &:not(:first-child) {
            margin-left: 24px;
          }
        }
      }
      .component-preview-wrapper {
        position: relative;
        width: 264px;
        height: 468px;
        border-radius: 10px;
        border: 1px solid #ebebeb;
        overflow: hidden;
        .video {
          .not-support {
            padding-top: 160px;
            text-align: center;
            .empty-text {
              margin-top: 8px;
              font-size: 12px;
              line-height: 17px;
              color: #999;
            }
          }
        }
      }
    }
  }

  ::v-deep  .el-radio-group {
    .el-radio-button__inner {
      padding-left: 15px;
      padding-right: 15px;
      min-width: 100px;
      height: 34px;
      background: #f2f2f2;
      border: 1px solid transparent;
      color: #333;
      // border-radius: 4px;
      &:hover {
        background-color: #eff0fe;
      }
    }
    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      color: #194ce5;
      border: 1px solid #194ce5;
      background-color: #fff;
      box-shadow: none;
    }
  }
}
</style>